export class IndividualWallChartSummary {
    Category: string | null;
    Start: number | null;
    End: number | null;
    Color: string | null;
}
